import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initScaleUp() {
  // Définir l'état initial pour tous les éléments scale-up
  document.querySelectorAll(".scale-up").forEach(el => {
    gsap.set(el, {
      scale: 0,
      opacity: 0
    });
  });

  // Immediate animation
  document.querySelectorAll(".scale-up.immediate").forEach(el => {
    gsap.to(el, {
      scale: 1,
      opacity: 1,
      duration: 0.5,
      ease: "power2.out",
      delay: 0.1 // Petit délai pour éviter le flash
    });
  });

  // On-scroll animation
  document.querySelectorAll(".scale-up.on-scroll").forEach(el => {
    gsap.to(el, {
      scale: 1,
      opacity: 1,
      duration: 0.5,
      ease: "power2.out",
      scrollTrigger: {
        trigger: el,
        start: "top 80%",
        toggleActions: "play none none none"
      }
    });
  });
}

// Exposer la fonction globalement pour Barba.js
window.initScaleUp = initScaleUp;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initScaleUp);
} else {
  initScaleUp();
}
